import React from 'react';

const config = require('../../../configuration');

const NotFound = () => {
    return (
        <section id="features" className="section">
            <div className="container">
                <div className="row" style={{ paddingTop:'15%', color: '#fff' }}>
                    <div className="col-md-12 headline text-center">
                        <div className="d-flex justify-content-center align-items-center">
                            <h1 className="mr-3 pr-3 align-top border-right inline-block align-content-center">404</h1>
                            <div className="inline-block align-middle">
                                <h2 className="font-weight-normal lead" id="desc">Página no encontrada</h2>
                            </div>
                        </div>
                    </div>    
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="inline-block align-middle">
                                <button className="btn btn-primary" onClick={() => window.location.href=config.REDIRECCIONAMIENTO_GLOBAL}>Ir a cademonline.cl</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default NotFound;
